export default {
    yzFontColor(value) {
        return value ? 'color:#000' : 'color:#d0cdcd;';
    },
    getBackUrl(that, orderNo) {
        let _p_from = this.judgeBrowser2(),type = '',wxOpenId = localStorage.getItem("cdqcp_wxopenId"),tel = '';
        if (window.CHANNELTOKEN === 'gzhtrip') {
            type = sessionStorage.getItem("channelTokenName") || 'gzhtrip';
        }else if(window.CHANNELTOKEN === 'qdn'){
            type = sessionStorage.getItem("channelTokenName") || 'gzhtrip_qdn';
            wxOpenId =  localStorage.getItem("useCar_cdqcp_wxopenId");
            tel = '0855-8357372';
        }else{
            type = sessionStorage.getItem("channelTokenName")|| '';
        }

        let openId = localStorage.getItem("cdqcp_opid") || localStorage.getItem("useCar_cdqcp_opid");

        let obj = {
            //backUrl:encodeURIComponent(location.origin + "/shuttle2/#/orderList?openId=" + openId +"&channelName=" ),
            //backUrl:encodeURIComponent(location.origin + "/shuttle2/#/orderList[openId,businessNo,channelName]"),
            businessNo:orderNo,
            businessCode:'SHULTTE',
            userToken:openId,
            wxOpenId:wxOpenId,
            token:this.judgeBrowser(),
            tel:tel
        },originHref = location.origin;


        if(window.CHANNELTOKEN === 'qdn'){
            that.$http.get('/config/mainHomeUrl').then((result) => {
                that.$http.get(result.data + "/config/payhref", {params: {_p_from: _p_from, type: type}}).then((res) => {
                    obj.backUrl = encodeURIComponent(originHref + "/shuttle2/#/orderList?openId=" + openId +"&channelName=" +res.data['channelCode'])
                    let Url = this.getParseParamUrl(obj);
                    location.href = res.data['payHref'] + '/index.html?' + Url + '&channelName=' + res.data['channelCode'] || localStorage.getItem("cdqcp_channel") || localStorage.getItem("useCar_cdqcp_conns");
                })
            })
        }else {
            that.$http.get("/config/payhref", {params: {_p_from: _p_from, type: type}}).then((res) => {
                obj.backUrl = encodeURIComponent(originHref + "/shuttle2/#/orderList?openId=" + openId +"&channelName=" +res.data['channelCode'])
                let Url = this.getParseParamUrl(obj);
                location.href = res.data['payHref'] + '/index.html?' + Url + '&channelName=' + res.data['channelCode'] || localStorage.getItem("cdqcp_channel");
            })
        }

    },
    getHomeUrl(that,orderlist){
        let openId =localStorage.getItem('useCar_cdqcp_opid') || window.localStorage.getItem("cdqcp_opid");
        that.$http.get('/config/mainHomeUrl').then((res) => {
            localStorage.removeItem("useCar_cdqcp_unm");
            localStorage.removeItem("useCar_cdqcp_channel");
            localStorage.removeItem("useCar_cdqcp_wxopenId");
            if(orderlist){
                location.href = res.data + '/orders/allorders?openId=' + openId + '&isBindingPhone=' + localStorage.getItem('useCar_isBindingPhone')
            }else {
                location.href = res.data + '/?openId=' + openId + '&isBindingPhone=' + localStorage.getItem('useCar_isBindingPhone')
            }

        })
    },
    // jshint ignore: start
    //封装datePicker
    dateShow(endTimeO, intervalMinuteO, lastMinuteO, startTimeO, maxPreDayO, endMinute0) {
        var endTime = parseInt(endTimeO) //服务结束时间 23
        var intervalMinute = intervalMinuteO; // 间隔分钟数 10分钟
        var lastMinute = lastMinuteO;         // 最后的时间为
        var jgTime = 50;
        var startTime = parseInt(startTimeO);           //开始时间 10:00点
        var intValue = 0; //多少分钟后下单
        var maxPreDay = maxPreDayO; //5天数
        var endMinute = parseInt(endMinute0); //最后的分钟 59分钟
        var nowDate = new Date();
        var nowHours = nowDate.getHours();  //当前的小时 10
        var newMinutes = nowDate.getMinutes();
        var totalMinutes = newMinutes + parseInt(jgTime);
        var nowMinutes = 0;
        var gwFlag = 5;
        if (totalMinutes >= 60) {
            intValue = intValue + 1;
            nowMinutes = (totalMinutes - 60);
        } else {
            nowMinutes = newMinutes + parseInt(jgTime);
        }
        //当前的分钟数小于10，不等于0, 则加10
        if (nowMinutes < 10 && nowMinutes != 0) {
            gwFlag = nowMinutes < 5 ? 5 : 10;
            var gw = gwFlag - nowMinutes;
            nowMinutes = nowMinutes + gw;
        } else if ((nowMinutes + "").substr(1, 1) != "0") {
            gwFlag = parseInt((nowMinutes + "").substr(1, 1)) < 5 ? 5 : 10;
            var gw = gwFlag - parseInt((nowMinutes + "").substr(1, 1));
            nowMinutes = nowMinutes + gw;
        }

        //完成每个小时的设置
        function MakeTime(start, i, today) {

            var HN = new Object();
            if (today == "other") {
                if (i >= 7 && i < 10) {
                    i = "0" + i;
                }
            } else {
                if (i >= 7 && i < 10) {
                    i = "0" + i;
                }
            }
            HN.name = i + '时';
            HN.sub = [];
            HN.tyep = 0;
            for (var j = start; j <= lastMinute / intervalMinute; j++) {
                //console.log("start", start ,lastMinute, intervalMinute, lastMinute / intervalMinute, j,j * intervalMinute)
                var MN = new Object();
                MN.name = j * intervalMinute + '分';

                if (j * intervalMinute < 10) {
                    MN.name = '0' + j * intervalMinute + '分';
                }

                if (i == endTime && j * intervalMinute <= endMinute) {
                    //console.log( endTime, j * intervalMinute , endMinute,j * intervalMinute <= endMinute);
                    HN.sub.push(MN);
                } else {
                    if (i != endTime) {
                        HN.sub.push(MN);
                    }
                }
            }
            return HN;
        }

        //后面几天的时间
        function MakeTime2(i) {
            var HN = new Object();
            if (i == 1) {
                HN.name = '明天';
            } else {
                var now = new Date();
                now.setDate(now.getDate() + i);
                var m = now.getMonth() + 1;
                var d = now.getDate();
                if (m < 10) {
                    m = '0' + m;
                }
                if (d < 10) {
                    d = '0' + d;
                }
                HN.name = m + "月" + d + "日";
            }
            HN.sub = [];
            HN.tyep = 1;
            for (var i = startTime; i <= endTime; i++) {
                HN.sub.push(MakeTime(0, i, "other"));
            }
            return HN;
        }

        var fistTime = {};
        var fistTimeS = [];
        var secondTime = [];
        //今天可用的时间点
        if (nowHours + intValue == endTime && nowMinutes > endMinute || nowHours + intValue > endTime) {
        } else {
            for (var i = nowHours + intValue; i <= endTime; i++) {
                if (i >= startTime) {
                    if (i == nowHours + intValue && nowMinutes <= lastMinute) {
                        // console.log("nowMinutes111111111111111",nowMinutes, intervalMinute);
                        //当前时间加1H后的可选结果
                        fistTimeS.push(MakeTime(parseInt(nowMinutes / intervalMinute), i));
                    } else {
                        if (i != nowHours + intValue) {
                            //今天剩余时间点。
                            fistTimeS.push(MakeTime(0, i));
                        }
                    }
                }
            }
            ;
            fistTime.name = '今天';
            fistTime.sub = fistTimeS;
            fistTime.type = 1;
            secondTime.unshift(fistTime);
        }
        //后5天时间点
        for (var i = 1; i < maxPreDay; i++) {
            secondTime.push(MakeTime2(i));
        }
        //处理secondTime
        var data = [];
        for (var i = 0; i < secondTime.length; i++) {
            data.push({
                name: secondTime[i].name,
                value: i + "s",
                parent: 0
            })
            for (var j = 0; j < secondTime[i].sub.length; j++) {
                //console.log("secondTime[i].sub",secondTime[i].sub[j])
                data.push({
                    name: secondTime[i].sub[j].name,
                    value: i + "" + j + "ss",
                    parent: i + "s"
                })
                for (var z = 0; z < secondTime[i].sub[j].sub.length; z++) {
                    data.push({
                        name: secondTime[i].sub[j].sub[z].name,
                        value: z + "sss",
                        parent: i + "" + j + "ss"
                    })
                }
            }
        }

        return data;
    },
    //不正常的时间
    dateShow_noNormal(startDate, endDate, intervalMinute, maxPreDay0) {
        // console.log(startDate,endDate);
        /*startDate = "23:30";
        endDate =  "06:00";*/
        intervalMinute = 50; //多少时间之后开始计算
        var maxPreDay = maxPreDay0; //预售天数
        var lastMinute = 5; //间隔时间
        var zgMinute = 55; //公共的分钟数

        //计算出时间段
        var startTime = parseInt(startDate.split(":")[0]); //多少点
        var startMinute = parseInt(startDate.split(":")[1]); //多少分钟

        var newStartTime = parseInt(startDate.split(":")[0]);
        var newStartMinute = parseInt(startDate.split(":")[1]);


        //修改newStartMinute
        if (newStartMinute < 10 && newStartMinute != 0) {
            gwFlag = newStartMinute < 5 ? 5 : 10;
            var gw = gwFlag - newStartMinute;
            newStartMinute = newStartMinute + gw;
        } else if ((newStartMinute + "").substr(1, 1) != "0") {
            gwFlag = parseInt((newStartMinute + "").substr(1, 1)) < 5 ? 5 : 10;
            var gw = gwFlag - parseInt((newStartMinute + "").substr(1, 1));
            newStartMinute = newStartMinute + gw;
        }

        //定义当前时间
        var nowDate = new Date();
        var nowHours = parseInt(nowDate.getHours());  //当前的小时 10
        var newMinutes = parseInt(nowDate.getMinutes());


        //结束分钟
        var endTime = parseInt(endDate.split(":")[0]);
        var endMinute = parseInt(endDate.split(":")[1]);
        var flagTime = startTime >= endTime;

        // 判断设置的时间是否小于当前时间，如果小于则等于当前时间
        if (startTime < nowHours || (nowHours == startTime && startMinute < newMinutes)) {
            startTime = nowHours;
            startMinute = newMinutes;
        }
        //计算出0点之前的时间段
        var litteTime = [];
        for (var i = 0; i <= endTime; i++) {
            litteTime.push(i);
        }
        //console.log("startMinute",startTime,startMinute);
        // 为今天设置值
        var totalMinutes = startMinute + parseInt(intervalMinute);

        var intValue = 0, gwFlag = 0;
        if (totalMinutes >= 60) {
            startTime = startTime + 1;
            startMinute = (totalMinutes - 60);
        } else {
            startMinute = totalMinutes;
        }
        //计算区间段  计算出0点之后的区间段
        var bigTime = [];
        for (var i = startTime; i < 24; i++) {
            bigTime.push(i);
        }

        //当前的分钟数小于10，不等于0, 则加10
        if (startMinute < 10 && startMinute != 0) {
            gwFlag = startMinute < 5 ? 5 : 10;
            var gw = gwFlag - startMinute;
            startMinute = startMinute + gw;
        } else if ((startMinute + "").substr(1, 1) != "0") {
            gwFlag = parseInt((startMinute + "").substr(1, 1)) < 5 ? 5 : 10;
            var gw = gwFlag - parseInt((startMinute + "").substr(1, 1));
            startMinute = startMinute + gw;
        }

        //完成每个小时的设置
        function MakeTime(start, i, today) {
            var HN = new Object();
            if (today == "other") {
                if (i < 10) {
                    i = "0" + i;
                }
            } else {
                if (i < 10) {
                    i = "0" + i;
                }
            }
            HN.name = i + '时';
            HN.sub = [];
            HN.tyep = 0;

            for (var j = start; j <= zgMinute / lastMinute; j++) {
                //console.log("start", start ,lastMinute, intervalMinute, lastMinute / intervalMinute, j,j * intervalMinute)
                var MN = new Object();
                MN.name = j * lastMinute + '分';
                if (j * lastMinute < 10) {
                    MN.name = '0' + j * lastMinute + '分';
                }
                //  console.log("endMinute1111111111111111111111111111111111111111111111",parseInt(i), endTime,endMinute,parseInt(i) == endTime, j * lastMinute,endMinute, j * lastMinute <= endMinute);
                if (parseInt(i) == endTime && j * lastMinute <= endMinute) {
                    //console.log( endTime, j * intervalMinute , endMinute,j * intervalMinute <= endMinute);
                    HN.sub.push(MN);
                } else {
                    if (i != endTime) {
                        HN.sub.push(MN);
                    }
                }
            }
            return HN;
        }

        //后面几天的时间
        function MakeTime2(i) {
            var HN = new Object();
            if (i == 1) {
                HN.name = '明天';
            } else {
                var now = new Date();
                now.setDate(now.getDate() + i);
                var m = now.getMonth() + 1;
                var d = now.getDate();
                if (m < 10) {
                    m = '0' + m;
                }
                if (d < 10) {
                    d = '0' + d;
                }
                HN.name = m + "月" + d + "日";
            }
            HN.sub = [];
            HN.tyep = 1;
            // console.log("1111111111", flagTime);
            if (flagTime) {
                for (var i = 0; i <= endTime; i++) {
                    HN.sub.push(MakeTime(0, i, "other"));
                }
                for (var i = newStartTime; i <= 23; i++) {
                    if (i == newStartTime) {
                        HN.sub.push(MakeTime(parseInt(newStartMinute / lastMinute), newStartTime, "other"));
                    } else {
                        HN.sub.push(MakeTime(0, i, "other"));
                    }

                }
            } else {
                for (var i = 0; i <= endTime; i++) {
                    HN.sub.push(MakeTime(0, i, "other"));
                }
            }

            return HN;
        }

        var fistTime = {};
        var fistTimeS = [];
        var secondTime = [];
        //今天可用的时间点
        // console.log("startTime",startTime,endTime);
        if (startTime >= endTime && flagTime) {
            //满足开始分钟+50分钟后的时间
            for (var i = 0; i < bigTime.length; i++) {
                if (bigTime[i] >= startTime) {
                    if (i == 0) {
                        fistTimeS.push(MakeTime(parseInt(startMinute / lastMinute), bigTime[i]));
                    } else {
                        fistTimeS.push(MakeTime(0, bigTime[i]));
                    }
                }
            }
            fistTime.name = '今天';
            fistTime.sub = fistTimeS;
            fistTime.type = 1;
            secondTime.unshift(fistTime);
        } else {
            if (startTime == endTime && startMinute > endMinute || startTime > endTime) {
            } else {
                for (var i = startTime; i <= endTime; i++) {
                    if (i >= startTime) {
                        if (i == startTime && startMinute <= zgMinute) {
                            //当前时间加1H后的可选结果
                            fistTimeS.push(MakeTime(parseInt(startMinute / lastMinute), i));
                        } else {
                            if (i != nowHours + intValue) {
                                //今天剩余时间点。
                                fistTimeS.push(MakeTime(0, i));
                            }
                        }
                    }
                }
                ;
                fistTime.name = '今天';
                fistTime.sub = fistTimeS;
                fistTime.type = 1;
                secondTime.unshift(fistTime);
            }
        }

        //后5天时间点
        for (var i = 1; i < maxPreDay; i++) {
            secondTime.push(MakeTime2(i));
        }
        //  console.log("data",secondTime);
        //console.log("secondTime",secondTime);
        //处理secondTime
        var data = [];
        for (var i = 0; i < secondTime.length; i++) {
            data.push({
                name: secondTime[i].name,
                value: "day" + i + "s",
                parent: 0
            })
            for (var j = 0; j < secondTime[i].sub.length; j++) {
                //  console.log("secondTime[i].sub",secondTime[i].sub[j])
                data.push({
                    name: secondTime[i].sub[j].name,
                    value: "minute" + i + "" + j + "ss",
                    parent: "day" + i + "s"
                })
                for (var z = 0; z < secondTime[i].sub[j].sub.length; z++) {
                    var num = i * j * z + (i + j + z) + (z / j / i);
                    data.push({
                        name: secondTime[i].sub[j].sub[z].name,
                        value: "sec" + i + j + z + num + "sss",
                        parent: "minute" + i + "" + j + "ss"
                    })
                }
            }
        }
        localStorage.setItem("data", JSON.stringify(data));
        return data;
    },
    //正常的时间
    dateShow_normal(calStartTime, calStartMinute, startTime, startMinute, endTime, endMinute, maxPreDay, intervalMinute) {

        var maxPreDay = maxPreDay; //预售天数
        var lastMinute = 5; //间隔时间
        var zgMinute = 55; //公共的分钟数
        var intervalMinute = intervalMinute;
        //计算出时间段
        var calStartTime = calStartTime;
        var calStartMinute = calStartMinute;
        var startTime = startTime;
        var startMinute = startMinute;
        var endTime = endTime;
        var endMinute = endMinute;

        //完成每个小时的设置
        function MakeTime(start, i, today) {
            var HN = new Object();
            if (today == "other") {
                if (i < 10) {
                    i = "0" + i;
                }
            } else {
                if (i < 10) {
                    i = "0" + i;
                }
            }
            HN.name = i + '时';
            HN.sub = [];
            HN.tyep = 0;
            for (var j = start; j <= zgMinute / lastMinute; j++) {
                //console.log("start", start ,lastMinute, intervalMinute, lastMinute / intervalMinute, j,j * intervalMinute)
                var MN = new Object();
                MN.name = j * lastMinute + '分';
                if (j * lastMinute < 10) {
                    MN.name = '0' + j * lastMinute + '分';
                }
                //  console.log("endMinute1111111111111111111111111111111111111111111111",parseInt(i), endTime,endMinute,parseInt(i) == endTime, j * lastMinute,endMinute, j * lastMinute <= endMinute);
                if (parseInt(i) == endTime && j * lastMinute <= endMinute) {
                    //console.log( endTime, j * intervalMinute , endMinute,j * intervalMinute <= endMinute);
                    HN.sub.push(MN);
                } else {
                    if (i != endTime) {
                        HN.sub.push(MN);
                    }
                }
            }
            return HN;
        }

        //后面几天的时间
        function MakeTime2(i) {

            var HN = new Object();
            if (i == 1) {
                HN.name = '明天';
            } else {
                var now = new Date();
                now.setDate(now.getDate() + i);
                var m = now.getMonth() + 1;
                var d = now.getDate();
                if (m < 10) {
                    m = '0' + m;
                }
                if (d < 10) {
                    d = '0' + d;
                }
                HN.name = m + "月" + d + "日";
            }
            HN.sub = [];
            HN.tyep = 1;
            //console.log(startTime,endTime)
            for (var i = startTime; i <= endTime; i++) {
                if (i == startTime) {
                    HN.sub.push(MakeTime(parseInt(startMinute / lastMinute), i, "other"));
                } else {
                    HN.sub.push(MakeTime(0, i, "other"));
                }
            }
            return HN;
        }

        var fistTime = {};
        var fistTimeS = [];
        var secondTime = [];
        //今天可用的时间点
        if (calStartTime < endTime || (calStartTime < endTime && calStartMinute <= endMinute)) {
            for (var i = calStartTime; i <= endTime; i++) {
                if (i == calStartTime && calStartMinute != 0) {
                    fistTimeS.push(MakeTime(parseInt(calStartMinute / lastMinute), calStartTime));
                } else {
                    fistTimeS.push(MakeTime(0, i));
                }
            }
            fistTime.name = '今天';
            fistTime.sub = fistTimeS;
            fistTime.type = 1;
            secondTime.unshift(fistTime);
        }
        //后5天时间点
        for (var i = 1; i < maxPreDay; i++) {
            secondTime.push(MakeTime2(i));
        }
        // console.log("secondTime",secondTime);
        //处理secondTime
        var data = [];
        for (var i = 0; i < secondTime.length; i++) {
            data.push({
                name: secondTime[i].name,
                value: "day" + i + "s",
                parent: 0
            })
            for (var j = 0; j < secondTime[i].sub.length; j++) {
                //  console.log("secondTime[i].sub",secondTime[i].sub[j])
                data.push({
                    name: secondTime[i].sub[j].name,
                    value: "day" + i + "minute" + i + "" + j + "ss",
                    parent: "day" + i + "s"
                })
                for (var z = 0; z < secondTime[i].sub[j].sub.length; z++) {
                    var num = i * j * z + (i + j + z) + (z / j / i);
                    data.push({
                        name: secondTime[i].sub[j].sub[z].name,
                        value: "sec" + i + j + z + num + "sss",
                        parent: "day" + i + "minute" + i + "" + j + "ss"
                    })
                }
            }
        }
        //localStorage.setItem("data",JSON.stringify(data));
        return data;
    },
    //不正常的时间
    dateShow_noNormal2(calStartTime, calStartMinute, startTime, startMinute, endTime, endMinute, maxPreDay, intervalMinute) {
        var maxPreDay = maxPreDay; //预售天数
        var lastMinute = 5; //间隔时间
        var zgMinute = 55; //公共的分钟数
        var intervalMinute = intervalMinute;
        //计算出时间段
        var calStartTime = calStartTime;
        var calStartMinute = calStartMinute;

        var startTime = startTime;
        var startMinute = startMinute;

        var endTime = endTime;
        var endMinute = endMinute;

        //完成每个小时的设置
        function MakeTime(start, i, today) {
            var HN = new Object();
            if (today == "other") {
                if (i < 10) {
                    i = "0" + i;
                }
            } else {
                if (i < 10) {
                    i = "0" + i;
                }
            }
            HN.name = i + '时';
            HN.sub = [];
            HN.tyep = 0;

            for (var j = start; j <= zgMinute / lastMinute; j++) {
                //console.log("start", start ,lastMinute, intervalMinute, lastMinute / intervalMinute, j,j * intervalMinute)
                var MN = new Object();
                MN.name = j * lastMinute + '分';
                if (j * lastMinute < 10) {
                    MN.name = '0' + j * lastMinute + '分';
                }
                //  console.log("endMinute1111111111111111111111111111111111111111111111",parseInt(i), endTime,endMinute,parseInt(i) == endTime, j * lastMinute,endMinute, j * lastMinute <= endMinute);
                if (parseInt(i) == endTime && j * lastMinute <= endMinute) {
                    //console.log( endTime, j * intervalMinute , endMinute,j * intervalMinute <= endMinute);
                    HN.sub.push(MN);
                } else {
                    if (i != endTime) {
                        HN.sub.push(MN);
                    }
                }
            }
            return HN;
        }

        //后面几天的时间
        function MakeTime2(i) {
            var HN = new Object();
            if (i == 1) {
                HN.name = '明天';
            } else {
                var now = new Date();
                now.setDate(now.getDate() + i);
                var m = now.getMonth() + 1;
                var d = now.getDate();
                if (m < 10) {
                    m = '0' + m;
                }
                if (d < 10) {
                    d = '0' + d;
                }
                HN.name = m + "月" + d + "日";
            }
            HN.sub = [];
            HN.tyep = 1;
            for (var i = 0; i <= endTime; i++) {
                HN.sub.push(MakeTime(0, i, "other"));
            }
            for (var i = startTime; i <= 23; i++) {
                if (i == startTime && startMinute != 0) {
                    HN.sub.push(MakeTime(parseInt(startMinute / lastMinute), startTime, "other"));
                } else {
                    HN.sub.push(MakeTime(0, i, "other"));
                }
            }
            //   console.log("HN",HN);
            return HN;
        }

        var fistTime = {};
        var fistTimeS = [];
        var secondTime = [];
        //今天可用的时间点
        if (calStartTime < 24) {
            for (var i = calStartTime; i < 24; i++) {
                /*if(i == 24){
                    start = 0;
                    end =  endTime;
                    for(var j =  0; j <= endTime; j++){
                        fistTimeS.push(MakeTime(0, j));
                    }
                }*/
                // console.log("calStartMinute",calStartMinute);
                if (i == calStartTime && calStartMinute != 0) {
                    fistTimeS.push(MakeTime(parseInt(calStartMinute / lastMinute), calStartTime));
                } else {
                    fistTimeS.push(MakeTime(0, i));
                }
            }
            fistTime.name = '今天';
            fistTime.sub = fistTimeS;
            fistTime.type = 1;
            secondTime.unshift(fistTime);
        }
        //后5天时间点
        for (var i = 1; i < maxPreDay; i++) {
            secondTime.push(MakeTime2(i));
        }
        //console.log("secondTime",secondTime);

        //处理secondTime
        var data = [];
        for (var i = 0; i < secondTime.length; i++) {
            data.push({
                name: secondTime[i].name,
                value: "day" + i + "s",
                parent: 0
            })
            for (var j = 0; j < secondTime[i].sub.length; j++) {
                //  console.log("secondTime[i].sub",secondTime[i].sub[j])
                data.push({
                    name: secondTime[i].sub[j].name,
                    value: "day" + i + "minute" + i + "" + j + "ss",
                    parent: "day" + i + "s"
                })
                for (var z = 0; z < secondTime[i].sub[j].sub.length; z++) {
                    var num = i * j * z + (i + j + z) + (z / j / i);
                    data.push({
                        name: secondTime[i].sub[j].sub[z].name,
                        value: "sec" + i + j + z + num + "sss",
                        parent: "day" + i + "minute" + i + "" + j + "ss"
                    })
                }
            }
        }
        return data;
    },
    //合并时间组件
    dateShowNew(startDate, endDate, intervalMinute, maxPreDay0) {
        if (!startDate) {
            return;
        }
        //根据进来的时间节点判断是否跨天还是非跨天
        startDate = startDate;
        endDate = endDate;
        intervalMinute = intervalMinute; //多少时间之后开始计算
        var maxPreDay = maxPreDay0; //预售天数
        var lastMinute = 5; //间隔时间
        var zgMinute = 55; //公共的分钟数

        //计算出时间段
        var startTime = parseInt(startDate.split(":")[0]); //多少点
        var startMinute = parseInt(startDate.split(":")[1]); //多少分钟

        //开始时间(用于非今天)
        var newStartTime = parseInt(startDate.split(":")[0]);
        var newStartMinute = parseInt(startDate.split(":")[1]);

        //定义当前时间
        var nowDate = new Date();
        var nowHours = parseInt(nowDate.getHours());  //当前的小时 10
        var newMinutes = parseInt(nowDate.getMinutes());


        //结束分钟
        var endTime = parseInt(endDate.split(":")[0]);
        var endMinute = parseInt(endDate.split(":")[1]);

        var flagTime = startTime >= endTime;
        //处理今天的开始时间
        //1.当前时间+间隔时间<开始时间
        var totalMinutes = newMinutes + parseInt(intervalMinute);

        var intValue = 0, intMinuted = 0, gwFlag = 0;
        if (totalMinutes >= 60) {
            intValue = parseInt(totalMinutes / 60);
            intMinuted = parseInt(totalMinutes % 60);
        } else {
            intMinuted = totalMinutes;
        }

        //用于计算的开始时间
        var calStartTime = 0;
        var calStartMinute = 0;

        //判断与开始时间的比较
        if ((nowHours + intValue) < startTime || (nowHours + intValue == startTime && intMinuted < startMinute)) {
            calStartTime = startTime;
            calStartMinute = startMinute;
        } else {
            calStartTime = nowHours + intValue;
            calStartMinute = intMinuted;
        }
        //console.log("calStartTime",calStartTime,calStartMinute);
        //处理时间
        //修改newStartMinute
        if (calStartMinute < 10 && calStartMinute != 0) {
            gwFlag = calStartMinute < 5 ? 5 : 10;
            var gw = gwFlag - calStartMinute;
            calStartMinute = calStartMinute + gw;
            ;
        } else if (calStartMinute != 0 && (calStartMinute + "").substr(1, 1) != "0") {
            gwFlag = parseInt((calStartMinute + "").substr(1, 1)) < 5 ? 5 : 10;
            var gw = gwFlag - parseInt((calStartMinute + "").substr(1, 1));
            calStartMinute = calStartMinute + gw;

        }

        // console.log("dateShow_noNormal",flagTime);

        if (calStartMinute >= 60) {
            calStartTime += 1;
            calStartMinute = 60 - calStartMinute;
        }
        //console.log("calStartTime",calStartTime,calStartMinute);
        //如果是跨天
        if (flagTime) {
            //调整后的开始时间， 开始分钟，服务开始时间， 开始分钟， 结束时间， 结束分钟， 预收天数， 间隔时间
            return this.dateShow_noNormal2(calStartTime, calStartMinute, startTime, startMinute, endTime, endMinute, maxPreDay, intervalMinute);
        }
        return this.dateShow_normal(calStartTime, calStartMinute, startTime, startMinute, endTime, endMinute, maxPreDay, intervalMinute);
    },
    //验证是否小于0
    yzValue(val) {
        return val < 10 ? "0" + val : val;
    },
    //对日期格式的处理
    updateDate(str) {
        if (!str) {
            return;
        }
        //var str = "01月01日 06:30"
        let nowDate = new Date();
        let datat = str.split(' ');
        console.log("datat", datat);
        var year = nowDate.getFullYear();
        var mounth = nowDate.getMonth() + 1;
        if (datat[0] == "今天") {
            return nowDate.format('yyyy-MM-dd') + ' ' + datat[1].substring(0, 2) + ':' + datat[2].substring(0, 2)
        } else if (datat[0] == "明天") {
            var tomorrow = new Date(new Date().setDate(nowDate.getDate() + 1));
            return tomorrow.getFullYear() + '-' + this.yzValue(tomorrow.getMonth() + 1) + '-' + this.yzValue(tomorrow.getDate()) + ' ' + datat[1].substring(0, 2) + ':' + datat[2].substring(0, 2);
        } else {
            if (parseInt(datat[0].substring(0, 2)) < mounth) {
                year += 1;
            }
            return datat.length == 2 ? year + '-' + datat[0].substring(0, 2) + '-' + datat[0].substring(3, 5) + ' ' + datat[1].substring(0, 2) + ':' + datat[1].substring(3, 5) : year + '-' + datat[0].substring(0, 2) + '-' + datat[0].substring(3, 5) + ' ' + datat[1].substring(0, 2) + ':' + datat[2].substring(0, 2);
        }
    },

    //返回一个数组
    getPersonArr(num) {
        var arr = [], num = window.localStorage.getItem("personNum") || num;
        for (var i = 0; i < num; i++) {
            arr.push(i + 1);
        }
        return arr;
    },
    getDateTime(that, cityNo, serve) {
        var me = that, mine = this;
        return new Promise(function (resolve, reject) {
            let v = serve ? serve : 'queryStationConfig'
            me.$http.post(window.innerAPI + "?server=" + v, {"cityNo": cityNo}).then(res => {
                if (res.data.code) {
                    return;
                }
                var res = res.data.data;
                var endTime = res.data.lastSaleEndTime.split(':') //服务结时间的多少点(23点)
                var intervalMinute = 5 //parseInt(res.data.intervalMinute); // 间隔分钟数 10
                var lastMinute = 55;         // 多少分钟后显示
                var laterTime = res.data.lastMinute ? parseInt(res.data.lastMinute) : "";
                var maxPreDay = res.data.preDay;           // 最大预售天数 5天
                var startTime = res.data.lastSaleStartTime.split(':');           //开始时间 10:00点
                var endMinute = endTime[1];
                // mine.dateShow_noNormal(res.data.lastSaleStartTime, res.data.lastSaleEndTime)
                var data = mine.dateShowNew(res.data.lastSaleStartTime, res.data.lastSaleEndTime, parseInt(res.data.lastInitOrderTime), parseInt(res.data.preDay));
                // var data = [];
                if (parseInt(startTime[0]) < parseInt(endTime[0])) {
                    /*data = mine.dateShow(endTime[0], intervalMinute, lastMinute, startTime[0], maxPreDay, laterTime, endMinute);*/
                }
                //判断设置的时间是正常的还是不正常的
                var obj = {
                    jspickerDate: data,
                    personList: mine.getPersonArr(res.data.number)
                }

                resolve(obj);
            }).catch(err => {
                reject(err);
            })
        });
    },
    //验证当前坐标是否在服务区
    checkCurrPoint(that, point) {
        //  console.log("that", that);
        return new Promise(function (resolve, reject) {
            that.$http.post(window.innerAPI + "?server=checkExistServiceArear", {point: point,channelCode:localStorage.getItem('useCar_jb_channelCode')}).then(function (data) {
                //console.log("data", data);
                resolve(data);
            }).catch(function (err) {
                reject(err);
            });
        })
    },
    getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg)
        if (window.location.hash.split('?').length > 1) {
            var c = window.location.hash.split('?')[1]
            r = c.match(reg)
        }
        // var r = window.location.hash.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]);
        return null;
    },
    //验证当前当前浏览器是否在微信
    judgeBrowser() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return "weixin";
        } else {
            return localStorage.getItem("appFrom") ? "app" : "directMSite";
        }
    },
    //验证当前当前浏览器是否在微信
    judgeBrowser2() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return "weixin";
        } else {
            return localStorage.getItem("appFrom") ? localStorage.getItem("appFrom") : "";
        }
    },
    //定位
    promisePosition: new Promise(function (resolve, reject) {
        /* var map = new BMap.Map("allmap"), that =  this;
         var point = new BMap.Point(116.331398,39.897445);
         map.centerAndZoom(point,12);
         var geolocation = new BMap.Geolocation();
         this.$store.dispatch('showLoading')
         geolocation.getCurrentPosition(function(r){
         if(this.getStatus() == BMAP_STATUS_SUCCESS){
         window.localStorage.setItem("jb-CurrentPosition", r.point.lng+","+r.point.lat)
         that.$store.dispatch('hideLoading'); //显示showLoading
         }else{
         that.$store.dispatch('hideLoading'); //显示showLoading
         that.$vux.toast.show({
         text: "定位失败,请选择上车地点",
         type:"text"
         })
         localStorage.removeItem("jb-CurrentPosition");
         }
         },{enableHighAccuracy: true})*/
    }),
    /**
     * {name:'tom','class':{className:'class1'},classMates:[{name:'lily'}]}
     * parseParam(obj);
     //output: "name=tom&class.className=class1&classMates[0].name=lily"
     * parseParam(obj,'stu');
     //output: "stu.name=tom&stu.class.className=class1&stu.classMates[0].name=lily"
     * @param param 将要转为URL参数的字符串对象
     * @param key URL参数字符串的前缀
     * @returns {string} URL参数字符串
     */
    getParseParamUrl: function (param, key) {
        if(param==null) return '';
        let paramStr = "",t = typeof (param);
        if (t === 'string' || t === 'number' || t === 'boolean') {
            paramStr += '&' + key + "=" + encodeURIComponent(param);
        } else {
            for (let i in param){
                let k = (key == null) ? i : key + (param instanceof Array ? "[" + i + "]" : "." + i);
                paramStr += this.getParseParamUrl(param[i], k);
            }

        }
        return paramStr;
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js